import React, { useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { authApi } from "../api-calls/user-requests";
import { SUBSCRIPTION_LIST } from "../api-calls/api-urls";

function FunctionalLayout() {
  const [plans, setPlans] = useState([]);
  const [selectedValue, setSelectedValue] = useState('');
  const navigate = useNavigate();
  const user = JSON.parse(sessionStorage.getItem("userInfo"));

  useEffect(() => {
    if (!user) {
      navigate("/login");
    }
  }, [user, navigate]);

 

  const getPlansDetails = async () => {
    try {
      const { data } = await authApi.get(SUBSCRIPTION_LIST);
      setPlans(data);
      if (data?.length > 0 && data[0].durations?.length > 0) {
        setSelectedValue(data[0].durations[0]._id);
      }
    } catch (err) {
      console.error("Error fetching plans", err);
    }
  };

  useEffect(() => {
    getPlansDetails();
  }, []);

  return (
    <div>
      <Outlet context={{  plans, selectedValue }} />
    </div>
  );
}

export default FunctionalLayout;
